<template>
  <div class="base-breadcrumb">
    <span v-for="link in links" :key="link" class="base-breadcrumb__item">
      {{ link }}
    </span>
  </div>
</template>

<script>
export default {
  name: "BaseBreadcrumb",
  props: {
    links: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped lang="scss">
.base-breadcrumb {
  display: inline-block;
  color: $color-blue-300;
  cursor: default;

  &__item {
    & + & {
      padding-left: 20px;
      position: relative;

      &::before {
        content: ">";
        position: absolute;
        font-weight: 300;
        left: 10px;
        transform: translate(-50%);
      }
    }

    &:last-child {
      font-weight: 700;
    }
  }
}
</style>
